export enum ProductType {
  RemoteSigning = 'RemoteSigning',
  KRON = 'KnownSignerRON',
  Hybrid = 'Hybrid',
  IPEN = 'IPEN',
}
